const urlName = '/usercenter/v2/t-b/user'

export default (API) => ({
    getUserInfo(item) {
		return API({ url: `${urlName}/getUserInfo` })
	},
})
